export default "__VITE_ASSET__B1lWA9P4__"